import React from 'react';

class StatModule extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="article__data">
        <div className="container--xl ma p15 f fw">
          <div className="article__data_single ac">
            <h5 className="caps ls m0 p0">{data.topTitle}</h5>
            <h1 className="article__data_large sans m0 p0">{data.topStat}</h1>
          </div>
        </div>
        <div className="article__data_arrows container--m ma ac">
          <div className="article__data_top rel y bcb"></div>
          <div className="article__data_lines x bcb"></div>
          <div className="f jce x">
            <div className="article__data_bottom y bcb rel right"></div>
          </div>
        </div>
        <div className="container--xl ma p15 f jce">
          <div className="article__data_single ac">
            <h5 className="caps ls m0 p0">{data.bottomStatTitle}</h5>
            <h1 className="article__data_large sans m0 p0">{data.bottomStat}</h1>
          </div>
        </div>
      </div>
    );
  }
}

export default StatModule;
